import { render, staticRenderFns } from "./ReturnForm.vue?vue&type=template&id=2f64ed1e&scoped=true&"
import script from "./ReturnForm.vue?vue&type=script&lang=js&"
export * from "./ReturnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f64ed1e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ErrorsMsgs: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ErrorsMsgs.vue').default})
